import { styled } from '@linaria/react';

import { fonts, layout, primitives, radius, semantic, space } from '../../theme/tokens';

export const ContentColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 0;
`;

export const FormArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;

  & button[type='submit'] {
    height: 56px;
    border-radius: ${radius('button', 'radius-full')};
    font-size: ${fonts.size.base};
  }

  & input:not([type='checkbox']) {
    height: 72px;
    border-radius: ${radius('input', 'radius-md')};
    font-size: ${fonts.size.base};
    padding: 0 ${layout.horizontalPadding};
  }
`;

export const HeadingBlock = styled.div`
  text-align: center;
`;

export const Heading = styled.h2`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: ${primitives.typography.tracking.tight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
  }
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const FormError = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.danger};
  text-align: center;
`;

export const BackRow = styled.div`
  text-align: center;
  margin-top: ${space['space-200']};
`;

export const SuccessMessage = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${semantic.text.primary};
  text-align: center;
  line-height: ${primitives.typography.lineHeight.loose};
  margin: 0;
  width: 100%;
`;
